export const staff = "staff";
export const students = "students";
export const divisions = "divisions";
export const levels = "levels";
export const buildings = "buildings";
export const classrooms = "classrooms";
export const classTime = "classTime";
export const classes = "classes";
export const lessons = "lessons";
export const admissions = "admissions";
export const admittedStudents = "admittedStudents";
export const sosInfo = "sosInfo";
export const deletedClassInfo = "deletedClassInfo";
export const configs = "configs";
export const attendanceInfo = "attendenceInfo";
export const days = [
  {
    name: "Sunday",
    value: "SUN",
  },
  {
    name: "Monday",
    value: "MON",
  },
  {
    name: "Tuesday",
    value: "TUE",
  },
  {
    name: "Wednesday",
    value: "WED",
  },
  {
    name: "Thursday",
    value: "THU",
  },
  {
    name: "Friday",
    value: "FRI",
  },
  {
    name: "Saturday",
    value: "SAT",
  },
];
export const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];
export const lessonsArray = [
  "L1",
  "L2",
  "L3",
  "L4",
  "L5",
  "L6",
  "L7",
  "L8",
  "L9",
  "L10",
  "R1",
  "E1",
  "L11",
  "L12",
  "L13",
  "L14",
  "L15",
  "L16",
  "L17",
  "L18",
  "L19",
  "L20",
  "R2",
  "E2",
  "L21",
  "L22",
  "L23",
  "L24",
  "L25",
  "L26",
  "L27",
  "L28",
  "L29",
  "L30",
  "R3",
  "E3",
  "L31",
  "L32",
  "L33",
  "L34",
  "L35",
  "L36",
  "L37",
  "L38",
  "L39",
  "L40",
  "R4",
  "E4",
];

let count = new Date().getFullYear() - 2;
export const intakeYears = new Array(5)
  .fill(1)
  .map((e, index) => index + count);

export const calculateAge = (dob) => {
  // console.log({ dob });
  if (!dob) {
    return "Enter DOB First";
  }
  return new Date(new Date() - new Date(dob)).getUTCFullYear() - 1970;
};

export const reactSelectTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    text: "#000",
    primary25: "#F5F5F5",
    primary50: "#B5B5B5",
    primary: "#E6007E",
  },
});
